import { render, staticRenderFns } from "./chanyetouzi.vue?vue&type=template&id=3f2d5fd0&"
import script from "./chanyetouzi.vue?vue&type=script&lang=js&"
export * from "./chanyetouzi.vue?vue&type=script&lang=js&"
import style0 from "./chanyetouzi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports